import { Dropdown } from '@cxc/react-fds-components';
import React from 'react';
import { Control, Controller, FieldValues } from 'react-hook-form';
import { AemDropdown } from '../../constants/types/AemTypes';
import {
  RequiredErrorMessage,
  Validator,
  generateRules,
} from './generateRules';

interface ControlledDropdownProps<T extends FieldValues> {
  name?: string;
  control: Control<T, unknown>;
  defaultValue?: string;
  placeholder?: string;
  dropdownValues: { label: string; value: string }[];
  field?: AemDropdown;
  validator?: Validator;
  additionalOnChange?: () => void;
}

const ControlledDropdown = <T extends FieldValues>({
  control,
  defaultValue = '',
  placeholder,
  dropdownValues,
  field,
  validator,
  additionalOnChange = undefined,
  ...rest
}: ControlledDropdownProps<T>) => {
  if (!field) return <></>;

  const { id, label } = field;
  const rules = generateRules(field, validator);
  const required = (rules.required as RequiredErrorMessage)?.value;

  return (
    <div data-testid={id ? `${id}-dropdown-wrapper` : undefined}>
      <Controller
        name={id}
        control={control as Control}
        defaultValue={defaultValue}
        rules={rules}
        render={({ field: { onChange, value }, fieldState: { error } }) => (
          <Dropdown
            options={dropdownValues}
            id={id ? `${id}-dropdown` : undefined}
            label={required ? `${label} *` : label}
            placeholder={required ? `${placeholder} *` : placeholder}
            value={value as string | number}
            onChange={({ value }) => {
              onChange(value);
              if (additionalOnChange) {
                additionalOnChange();
              }
            }}
            error={error?.message}
            ariaRequired={!!required}
            {...rest}
          />
        )}
      />
    </div>
  );
};

export default ControlledDropdown;
